import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Marketing routes are prerendered to static HTML by scripts/prerender.mjs so
// crawlers see real content. We deliberately client-render (not hydrate) over
// that HTML: pages render nondeterministically (shuffled reviews, live demos),
// so hydration would mismatch and fall back to client rendering anyway.
const container = document.getElementById('root');
container.innerHTML = '';
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
